module.exports = __webpack_public_path__ + "static/media/spp-icon.91daef03.svg";